import { render } from "./DiscountTag.vue?vue&type=template&id=543223a0"
import script from "./DiscountTag.js?vue&type=script&lang=js"
export * from "./DiscountTag.js?vue&type=script&lang=js"

import "./DiscountTag.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__